import React, { useEffect, useState } from 'react';

interface IProps {
    /**
     * @description Adds modifiers to the class of the component
     * @example Alignment: left, right
     * @example Colors: black, mine-shaft, brownish-grey, brown-grey, alabaster
     */
    children?: any;
    modifiers?: string | string[];
    style?: React.CSSProperties;
    onClick?: () => void;
}

/**
 * Place in HanTableRow.tsx. A table-cell with possible background-colors from the corporate identity of HAN.
 *
 * Possible modifiers:
 *
 *
 * - Colors
 *      - black
 *      - mine-shaft
 *      - brownish-grey
 *      - brown-grey
 *      - alabaster
 * - Alignment
 *      - left
 *      - right
 *
 * @param children Content of the component.
 * @param modifiers The modifiers which will be added to the components class.
 *

 * @param style
 * @param onClick
 * @param style
 * @param onClick
 */
const HanTableCell: React.FC<IProps> = ({ children, modifiers, style, onClick }) => {
    const baseClassName = "han-table__cell";
    const [className, setClassName] = useState<string>(baseClassName);

    useEffect(() => {
        if(modifiers) {
            let classNameString = baseClassName;

            if(Array.isArray(modifiers)) {
                modifiers.forEach(modifier => {
                    classNameString += ` ${baseClassName}--${modifier}`;
                })
            } else {
                classNameString += ` ${baseClassName}--${modifiers}`;
            }
            
            setClassName(classNameString);
        }
    }, [modifiers])

    return (
        <td className={className} onClick={onClick} style={style}>
            {children}
        </td>
    )
}

export default HanTableCell;
